import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { validationMessages } from 'src/app/cart/validation-messages';

@Component({
  selector: 'app-modify-contact-data',
  templateUrl: './modify-contact-data.component.html',
  styleUrls: ['./modify-contact-data.component.scss'],
  standalone: false
})
export class ModifyContactDataComponent implements OnInit {

  @Input() form: UntypedFormGroup;

  validationMessages = validationMessages;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() { }

  // TODO: To helper (dont know which one)
  fieldIsInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return field && field.invalid && (field.dirty || field.touched);
  }

  onSubmit() {
    if (this.form.valid) {
      this.modalController.dismiss(this.form.value);
    }
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
